import React from "react";

import { FromInt } from "../../helpers/NumberTools";
import { jalaliDateWithTime } from "../../helpers/convertDate.helper";

//icon
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MessageIcon from "@mui/icons-material/Message";

const TicketCard = (props) => {
  const { message } = props;
  return (
    <>
      <div
        className={`row cards ${
          message.customerId
            ? "bg-info  bg-gradient text-dark"
            : "bg-primary  bg-gradient text-light"
        } `}
      >
        <div className="col-12 ">
          <MessageIcon className="m-1" /> {FromInt(message.text)}
          <hr />
        </div>
        <div className="col-12  ">
          <InsertInvitationIcon className="m-1" />{" "}
          {FromInt(jalaliDateWithTime(message.createdAt))}
        </div>

        {message.ticketMessageMedias.length !== 0 ? (
          <>
            <div className="col-12 ">
              <hr />
            </div>
            {message.ticketMessageMedias.map((media, index) => {
              return (
                <div key={index} className="col-12  ">
                  <AttachFileIcon className="m-1" />{" "}
                  <a
                    className={`${
                      message.customerId ? " text-dark" : " text-light"
                    } `}
                    href={media.mediaObj.mediaUrl}
                    rel={media.title}
                    alt={media.title}
                    download="download"
                    target="blank"
                  >
                    {FromInt(media.title)}
                  </a>
                </div>
              );
            })}
          </>
        ) : null}
      </div>
    </>
  );
};

export default TicketCard;
